<template lang="pug">
.CampaignScheduler
  // Modal
  b-modal(
    ref='modal-campaign-scheduler',
    centered,
    modal-class='CampaignScheduler-Modal',
    v-model='modalShow'
  )
    // Modal Title
    template(v-slot:modal-title)
      .CampaignScheduler-ModalHeader.text-first-uppercase
        span {{ $t("setup_schedule") }}

    // Modal Content
    form.CampaignScheduler-Form

      // Date Picker
      .form-group
        label.form-label.form-label-lg {{ $t("delivery_date") }}
        b-form-datepicker(v-model='value.scheduleDate' :min='minDate' start-weekday='1')

      // Time Picker
      .form-group
        label.form-label.form-label-lg {{ $t("delivery_time") }}
        b-form-timepicker(
          v-model='value.scheduleTime'
          required
          minutes-step='5'
        )

      p
        strong {{ $t("campaign_send_audience_number", { number: Intl.NumberFormat().format(contacts) }) }}

      p {{ $t("split_audiences_batches") }}

      .row
        // Batches Selector
        .col-4
          .form-group
            label.form-label.form-label-lg {{ $t("batches") }}
            b-form-select(v-model="value.batches" :options="batchesOptions" )

        // Batch Items
        .col-4
          .form-group
            label.form-label.form-label-lg {{ $t("contacts_batch") }}
            div {{ Intl.NumberFormat().format(contactsByBatch) }}

        // Frequency
        .col-4
          .form-group
            label.form-label.form-label-lg {{ $t("frequency") }}
            b-form-select(v-model="value.batchMinutes" :options="batchMinutesOptionsFiltered" )

    // Modal Footer
    template(v-slot:modal-footer)
      .CampaignScheduler-ModalFooter
        ja-button(
          :disabled='isSchedulerModalSubmitDisabled',
          :on-click='onSave',
          :text='$t("schedule_campaign")',
          type='primary'
        )
</template>

<script>
const now = new Date()
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
const minDate = new Date(today)

const batchMinutesOptions = [
  { value: 1, text: '1 minutes' },
  { value: 2, text: '2 minutes' },
  { value: 3, text: '3 minutes' },
  { value: 4, text: '4 minutes' },
  { value: 5, text: '5 minutes' },
  { value: 10, text: '10 minutes' },
  { value: 15, text: '15 minutes' },
  { value: 20, text: '20 minutes' },
  { value: 30, text: '30 minutes' },
  { value: 60, text: '1 hour' },
  { value: 120, text: '2 hours' },
  { value: 180, text: '3 hours' },
  { value: 240, text: '4 hours' },
  { value: 300, text: '5 hours' },
  { value: 360, text: '6 hours' },
  { value: 480, text: '8 hours' },
  { value: 720, text: '12 hours' },
]

const LIMIT_SENDS = 1000

export default {
  name: 'CampaignScheduler',

  props: {
    contacts: {
      type: [Number, String],
      default: 0
    },

    value: {
      type: Object,
      required: true
    },

    onSave: {
      type: Function,
      default: () => {}
    },
  },

  data () {
    return {
      batchMinutesOptions,
      minDate,
      modalShow: false,
    }
  },

  computed: {
    batchesOptions () {
      const total = this.contacts

      if (!this.contacts) return [1]

      const minBatches = Math.ceil(total / LIMIT_SENDS)
      const maxBatches = Math.min(minBatches + 10, total)
      const count = maxBatches - minBatches + 1

      return Array.from({ length: count }, (_, i) => minBatches + i)
    },

    contactsByBatch () {
      const { batches } = this.value
      return batches
        ? Math.round(this.contacts / batches)
        : this.contacts
    },

    isSchedulerModalSubmitDisabled () {
      const { scheduleDate, scheduleTime } = this.value
      return !scheduleDate || !scheduleTime
    },

    batchMinutesOptionsFiltered () {
      const contacts = this.contactsByBatch

      const minMinutes = Math.ceil(contacts / 600)

      return this.batchMinutesOptions.filter(option => option.value >= minMinutes)
    },
  },

  created () {
    this.setDefaultBatches()
    this.setDefaultBatchMinutes()
    this.setBatchItems()
  },

  updated () {
    this.setBatchItems()
  },

  methods: {
    open () {
      this.$refs['modal-campaign-scheduler'].toggle()
    },

    setDefaultBatches () {
      if (!this.value.batches || !this.batchesOptions.includes(this.value.batches)) {
        this.$set(this.value, 'batches', this.batchesOptions[0])
      }
    },

    setDefaultBatchMinutes () {
      const filtered = this.batchMinutesOptionsFiltered

      if (!this.value.batchMinutes || !filtered.some(o => o.value === this.value.batchMinutes)) {
        this.$set(this.value, 'batchMinutes', filtered[0]?.value || 5)
      }
    },

    setBatchItems () {
      this.$set(this.value, 'batchItems', this.contactsByBatch)
    }
  },
}
</script>

<style lang="sass" scoped>
</style>
